export class FileUtils {

  public static rename(file: File, newName: string) {
    const blob = file.slice(0, file.size, file.type);
    return new File([blob], newName, { type: file.type });
  }

  public static extension(file: File) {
    const infos = file.name.split('.');
    return infos[infos.length - 1];
  }

}
